import { canadaGuaranteeData } from "../../data/canadaTaxData";
import { Shield } from "lucide-react";

export const CanadaGuaranteeSection = () => (
  <section className="py-24 px-6 bg-white text-center">
    <div className="max-w-xl mx-auto">
      <div className="bg-[#FAFCFF] border-2 border-[#D4A843] rounded-2xl p-10 shadow-lg shadow-[#D4A843]/10">
        <div className="w-16 h-16 rounded-full bg-[#FFFDF5] border-2 border-[#D4A843]/30 flex items-center justify-center mx-auto mb-6">
          <Shield size={30} className="text-[#D4A843]" />
        </div>
        <h2 className="text-[#0B1829] font-black text-2xl mb-5" style={{ fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "-0.03em" }}>
          {canadaGuaranteeData.headline}
        </h2>
        <p className="text-[#5A6A7A] text-sm leading-loose" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          If your return is{" "}
          <strong className="text-[#0B1829] font-bold">not filed within 48 business hours</strong>{" "}
          of receiving your complete documents, we refund $10 from your fee. Automatically.
        </p>
        <div className="h-px bg-[#E8ECF0] my-5" />
        <p className="text-[#5A6A7A] text-sm leading-loose" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          If you're{" "}
          <strong className="text-[#0B1829] font-bold">not completely satisfied</strong>{" "}
          with our service, we'll make it right. That's our promise.
        </p>
        <div className="mt-6 inline-flex items-center gap-2 bg-[#FDF1F2] border border-[#C8283A]/20 text-[#C8283A] text-xs font-black uppercase tracking-widest px-4 py-2 rounded-full" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          <Shield size={12} />
          You are not risking your money
        </div>
      </div>
    </div>
  </section>
);
